import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const matchingQuestionSideHtml = (side) => {
    if (!side) {
        return ''
    }

    if (side.type === 'image' && side.image) {
        const relatedMediaId = escapePrintViewText(side.related_media_id || '')

        return `image media id: ${relatedMediaId}`
    }

    if (side.text) {
        return escapePrintViewText(side.text)
    }

    return ''
}

const buildMatchingQuestionPrintView = (content) => {
    const prompt = replaceMediaLikeTagsWithIds(content.question_prompt || '')
    const answerPairs = content.answer_pairs || []
    const pairsHtml = answerPairs
        .map((answerPair) => {
            const left = matchingQuestionSideHtml(answerPair.left)
            const right = matchingQuestionSideHtml(answerPair.right)

            if (!left && !right) {
                return ''
            }

            return `<p>${left} =&gt; ${right}</p>`
        })
        .filter(Boolean)
        .join('')

    return `${prompt}${pairsHtml}`
}

export {buildMatchingQuestionPrintView}
